import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../../styles/common/Layout.css';

const Layout = () => {
    const { user, logout, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    // Show loading while auth is initializing
    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    // Redirect if no user
    if (!user) {
        navigate('/login');
        return null;
    }

    const menuItems = [
        { path: '/admin/dashboard', label: 'Dashboard', icon: '📊' },
        { path: '/admin/clients', label: 'Clients', icon: '👥' },
        { path: '/admin/account-statement', label: 'Account Statement', icon: '📋' },
        { path: '/admin/current-bets', label: 'Current Bet', icon: '🎲' },
        { path: '/admin/settlement', label: 'Manual Settlement', icon: '⚙️' },
        { path: '/admin/match-lock', label: 'Match Lock', icon: '🔒' },
        { path: '/admin/delete-bets', label: 'Delete Bets', icon: '🗑️' }
    ];

    return (
        <div className="layout">
            {/* Top Header */}
<header className="top-header">

    {/* Mobile Menu Button */}
    <button 
        className="mobile-menu-btn"
        onClick={() => setShowMobileMenu(!showMobileMenu)}
    >
        ☰
    </button>

    <div className="logo">
        <h2>Admin Panel</h2>
    </div>
    
    {/* Desktop Nav (unchanged) */}
    <div className="header-nav">
        {menuItems.map((item) => (
            <Link 
                key={item.path} 
                to={item.path} 
                className={`header-nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
                <span className="nav-icon">{item.icon}</span>
                {item.label}
            </Link>
        ))}
    </div>

    {/* User Dropdown (unchanged) */}
    <div className="user-dropdown">
        <button 
            className="dropdown-toggle"
            onClick={() => setShowDropdown(!showDropdown)}
        >
            <span className="user-avatar">👤</span>
            <span className="usernamexcc">{user?.username}</span>
            <span className="role-badge">Admin</span>
            <span className="dropdown-arrow">▼</span>
        </button>
        
        {showDropdown && (
            <div className="dropdown-menu">
                <Link to="/admin/change-password" className="dropdown-item">
                    🔒 Change Password
                </Link>
                <button onClick={handleLogout} className="dropdown-item logout">
                    🚪 Logout
                </button>
            </div>
        )}
    </div>

    {/* Mobile Dropdown Menu */}
    {showMobileMenu && (
        <div className="mobile-nav">
            {menuItems.map((item) => (
                <Link 
                    key={item.path} 
                    to={item.path}
                    onClick={() => setShowMobileMenu(false)}
                    className={`mobile-nav-link ${location.pathname === item.path ? 'active' : ''}`}
                >
                    {item.icon} {item.label}
                </Link>
            ))}
        </div>
    )}

</header>
            
            {/* Main Content */}
            <main className="main-contentx">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;